var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotation02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill:url(#SVGID_10_);}\n\t.st10{fill:url(#SVGID_11_);}\n\t.st11{fill:url(#SVGID_12_);}\n\t.st12{fill:url(#SVGID_13_);}\n\t.st13{fill:url(#SVGID_14_);}\n\t.st14{fill:url(#SVGID_15_);}\n\t.st15{fill:url(#SVGID_16_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.875,
    y1: 617.3439,
    x2: 795.4923,
    y2: 617.3439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M749.5,560.3c0-36.6,0-73.2,0-111.9c-25.1,0-48.9,0.1-72.8,0c-58.5-0.2-98.2-39.5-98.7-97.8 c-0.2-21.6,0-43.1,0-66.2c-6.9-0.3-12.5-0.9-18.1-0.9c-88.4,0-176.7,0-265.1,0c-39.6,0-57.8,18.3-57.9,58c0,183.7,0,367.4,0,551.1 c0,39.3,18.7,57.8,58.1,57.8c132.8,0.1,265.7,0.1,398.5,0c36.2,0,55.7-19.1,56.3-54.5c0.9-54.3,0.9-54.3,42.7-99.2 c0.7,4.7,1.8,8.3,1.8,11.9c0.1,30.4,0.4,60.8,0,91.3c-0.7,53.7-38.7,94.7-92.3,95.2c-139.3,1.1-278.5,1.2-417.8,0 c-53.5-0.4-92.1-41.8-92.1-95.3c-0.3-187.8-0.3-375.6,0-563.4c0.1-56.5,39.4-96.9,95.8-97.2c100.1-0.7,200.1-0.7,300.2,0.5 c12.1,0.1,26.9,6.3,35.8,14.6c52.4,48.5,103.4,98.3,154.7,148c5.3,5.1,11.8,11.9,12.5,18.4c3.3,32,11.5,64.8-9.3,94.8 c-10.2,14.8-18.9,30.6-28.2,46C752.3,561.1,750.9,560.7,749.5,560.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 656.286,
    y1: 591.2358,
    x2: 1008.0531,
    y2: 591.2358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M972.7,457c-7-3.9-12-6.7-18-9.9c-22.2,36.8-43.5,72.9-65.6,108.6c-51.7,83.6-105.5,165.7-170.3,240 c-12.2,14-26,26.9-40,39.1c-4.5,3.9-12.2,4.2-18.5,6.2c-1.3-6.4-5.3-13.6-3.6-19.1c9.5-30,18.3-60.5,31.2-89 c54.9-121.8,123.6-236,197.6-347c8-12,18.1-22.9,28.3-33.3c12.5-12.8,27.3-14.5,43.1-5.4c17.8,10.3,24.6,23,20.7,42 c-2,9.7-5.7,19-9.1,30.3c8.8,5.2,18,11,27.5,16.4c11.7,6.6,15.6,15.4,8.5,27.6c-33.8,58.1-67.7,116.1-101.3,174.4 c-6.2,10.8-12.3,8.9-18.9,1.4c-8.9-10.2-5.6-20.2,0.5-30.6c26-44.4,51.7-88.9,77.6-133.4C965.6,469.8,968.6,464.2,972.7,457z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.7892,
    y1: 596.8722,
    x2: 700.811,
    y2: 596.8722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M493,619.1c-59.1,0-118.1,0.1-177.2,0c-19.9,0-29.6-7.1-30-21.5c-0.4-14.8,10.3-23,30.6-23 c118.1,0,236.2,0,354.3,0.2c19.6,0,29.7,7.5,30.1,21.6c0.4,14.8-10,22.6-30.7,22.7C611.2,619.2,552.1,619.1,493,619.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.0512,
    y1: 685.1867,
    x2: 669.9,
    y2: 685.1867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M669.9,666c-5.7,11.8-10.9,24.1-17.7,35.4c-2,3.3-8.5,5.5-12.9,5.5c-109.4,0.3-218.7,0.2-328.1,0.3 c-14.4,0-24.3-6-25.1-20.9c-0.8-14.9,8.3-23,22.8-23.1c118.7-0.1,237.4,0.1,356.2,0.3C666.1,663.6,667.1,664.6,669.9,666z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.0648,
    y1: 773.3101,
    x2: 630.2,
    y2: 773.3101
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M630.2,751.6c-4.8,13.6-8.4,25.9-13.8,37.3c-1.5,3.3-8.1,5.9-12.4,5.9c-98.3,0.3-196.5,0.3-294.8,0.2 c-13.9,0-22.5-7.1-23.1-20.9c-0.6-12.9,6.5-22.2,19.6-22.2C413.2,751.4,520.8,751.6,630.2,751.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.7658,
    y1: 418.3116,
    x2: 428.3192,
    y2: 418.3116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M355.9,309.9c15.8-2.4,29.2-6.2,28.7,15.4c-0.1,2.7,6.9,6.9,11.2,8c27.5,7.3,28.1,8.2,15.6,36.1 c-11.6-2.1-23.5-6.1-35.3-5.8c-7.4,0.2-14.6,6.8-21.9,10.5c4.8,6.5,8.3,14.8,14.6,18.9c10.2,6.6,22.5,9.7,33.3,15.5 c17.4,9.4,26.7,24.5,26.2,44.4s-10.8,34.6-28.8,42.6c-9.4,4.2-16.4,8.1-14.5,20.1c1.7,10.3-4.2,13.2-13.5,13 c-8.3-0.2-16-0.5-14.9-11.7c1-10.5-3.9-15.1-13.9-15.4c-1.1,0-2.3-0.6-3.4-0.9c-28.4-6.6-30.2-10.9-16.2-38.1 c12.2,2.9,24.6,8.4,36.8,8c9.5-0.3,23.4-5.6,26.9-12.8c6.4-13-7.4-18.4-17.4-23.3c-11.6-5.6-24.1-9.5-34.7-16.5 c-28.5-18.8-27.9-59.1,1.8-75.5C350.3,334.9,359.6,327.8,355.9,309.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.6,
    y1: 508.9309,
    x2: 703.0187,
    y2: 508.9309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M576,531.1c-32.2,0-64.3,0.1-96.5-0.1c-17.8-0.1-27.9-8.3-27.9-22c0-13.6,10.2-22.2,27.9-22.2 c65.5-0.2,131-0.2,196.5,0.1c17.2,0.1,28.3,9.6,26.9,22.9c-1.7,15.5-11.9,21.5-26.9,21.4C642.6,531,609.3,531.1,576,531.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.1,
    y1: 893.05,
    x2: 315.3,
    y2: 893.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M294.9,925.6l-5.3-8.7c-1.2,0.2-2.6,0.3-4.1,0.3c-5.2,0-10-1.2-14.3-3.7c-4.3-2.4-7.8-5.8-10.3-10.1 s-3.8-9.2-3.8-14.6c0-5.4,1.3-10.3,3.8-14.6s6-7.7,10.3-10.1c4.3-2.4,9.1-3.6,14.3-3.6c5.2,0,9.9,1.2,14.3,3.6 c4.3,2.4,7.7,5.8,10.2,10.1s3.8,9.2,3.8,14.6c0,4.4-0.9,8.5-2.6,12.2s-4.1,6.9-7.1,9.5l11.2,15.1H294.9z M277.4,897.8 c1.9,2.2,4.5,3.3,8,3.3c3.4,0,6.1-1.1,7.9-3.3c1.9-2.2,2.8-5.2,2.8-8.9c0-3.8-0.9-6.8-2.8-9s-4.5-3.3-7.9-3.3c-3.5,0-6.2,1.1-8,3.3 c-1.9,2.2-2.8,5.2-2.8,9C274.6,892.6,275.5,895.5,277.4,897.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.6,
    y1: 889.35,
    x2: 368.4,
    y2: 889.35
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M336.8,861.5v31.1c0,2.5,0.6,4.6,1.7,6c1.1,1.5,2.9,2.2,5.4,2.2s4.3-0.7,5.5-2.2s1.8-3.5,1.8-6v-31.1h17.2 v31.1c0,5.2-1.1,9.7-3.3,13.4c-2.2,3.7-5.2,6.5-9,8.4s-8,2.8-12.7,2.8s-8.8-0.9-12.4-2.8c-3.6-1.9-6.4-4.6-8.4-8.3s-3-8.2-3-13.5 v-31.1L336.8,861.5L336.8,861.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.4,
    y1: 888.8501,
    x2: 431.1,
    y2: 888.8501
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M388.5,913.5c-4.3-2.4-7.8-5.8-10.3-10.1s-3.8-9.2-3.8-14.6c0-5.4,1.3-10.3,3.8-14.6s6-7.7,10.3-10.1 c4.3-2.4,9.1-3.6,14.3-3.6c5.2,0,9.9,1.2,14.3,3.6c4.3,2.4,7.7,5.8,10.2,10.1s3.8,9.2,3.8,14.6c0,5.4-1.3,10.3-3.8,14.6 s-5.9,7.7-10.3,10.1c-4.3,2.4-9.1,3.7-14.2,3.7C397.6,917.2,392.8,916,388.5,913.5z M410.7,897.8c1.9-2.2,2.8-5.2,2.8-8.9 c0-3.8-0.9-6.8-2.8-9s-4.5-3.3-7.9-3.3c-3.5,0-6.2,1.1-8,3.3c-1.9,2.2-2.8,5.2-2.8,9c0,3.7,0.9,6.7,2.8,8.9s4.5,3.3,8,3.3 C406.2,901.1,408.9,900,410.7,897.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 434.2,
    y1: 889.05,
    x2: 480.6,
    y2: 889.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M480.6,861.5v13.7H466v41.4h-17.3v-41.4h-14.5v-13.7H480.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 481.4,
    y1: 889.05,
    x2: 541.6,
    y2: 889.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M520.6,908.3h-18.4l-2.7,8.3h-18.1l20.2-55.1h19.9l20.1,55.1h-18.2L520.6,908.3z M516.4,895.3l-5-15.3 l-5,15.3H516.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 542.3,
    y1: 889.05,
    x2: 588.7,
    y2: 889.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M588.7,861.5v13.7h-14.6v41.4h-17.3v-41.4h-14.5v-13.7H588.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 593.4,
    y1: 889.05,
    x2: 610.7,
    y2: 889.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M610.7,861.5v55.1h-17.3v-55.1H610.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 617,
    y1: 888.8501,
    x2: 673.7,
    y2: 888.8501
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M631.1,913.5c-4.3-2.4-7.8-5.8-10.3-10.1s-3.8-9.2-3.8-14.6c0-5.4,1.3-10.3,3.8-14.6s6-7.7,10.3-10.1 c4.3-2.4,9.1-3.6,14.3-3.6s9.9,1.2,14.3,3.6c4.3,2.4,7.7,5.8,10.2,10.1s3.8,9.2,3.8,14.6c0,5.4-1.3,10.3-3.8,14.6 s-5.9,7.7-10.3,10.1c-4.3,2.4-9.1,3.7-14.2,3.7C640.2,917.2,635.4,916,631.1,913.5z M653.3,897.8c1.9-2.2,2.8-5.2,2.8-8.9 c0-3.8-0.9-6.8-2.8-9c-1.9-2.2-4.5-3.3-7.9-3.3c-3.5,0-6.2,1.1-8,3.3c-1.9,2.2-2.8,5.2-2.8,9c0,3.7,0.9,6.7,2.8,8.9 c1.9,2.2,4.5,3.3,8,3.3C648.8,901.1,651.4,900,653.3,897.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 679.8,
    y1: 889.05,
    x2: 732.7,
    y2: 889.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1799E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4698,
    style: {
      stopColor: "#29B0B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2BB67A"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M732.7,916.6h-17.3l-18.3-27.7v27.7h-17.3v-55.1h17.3l18.3,28.2v-28.2h17.3V916.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation02);
export default __webpack_public_path__ + "static/media/Quotation-02.e9ee13354354f86c6ee4cb0492675d1b.svg";
export { ForwardRef as ReactComponent };